export const ErrorEventEnum = {
	SILENCE_EVENT: '888.014.429',
	CAPTCHA_ERROR_OVER_LIMIT_EVENT: '888.014.412',
	INVALID_CLIENT_IP: '888.000.403',
};
